<div class="container-style">
  @if (loading) {
  <div class="p-4">
    <p-skeleton styleClass="custom-skeleton-header"></p-skeleton>
    <p-skeleton styleClass="custom-skeleton-body"></p-skeleton>
  </div>
  } @else {
  <app-custom-table [showRecover]="true" [headers]="headers" [data]="data" [previousFilters]="filters"
    [isFilterPersistent]="false" [showCheckbox]="true" [isMultipleSelect]="true" [selectAllByDefault]="true"
    (onPageChange)="onPageChange($event)" (onFilterChange)="onFilterChange($event)">
  </app-custom-table>
  }
</div>